export const validations_en_US: any = {
    validations_id_title_default: 'Upload photos of your documentation.',
    validations_id_title_pre_approved: 'Your documentation has been approved.',
    validations_id_title_approved: 'Your documentation has been approved.',
    validations_id_title_pending: 'Your documentation is under review.',
    validations_id_title_processing: 'Your documentation is under review.',
    validations_id_description: 'This way, you help us verify and support that you are the account holder from which you send your balance',

    validations_selfie_title_default: 'Add your selfie.',
    validations_selfie_title_pre_approved: 'Your selfie has been approved.',
    validations_selfie_title_approved: 'Your selfie has been approved.',
    validations_selfie_title_pending: 'Your selfie is under review.',
    validations_selfie_title_processing: 'Your selfie is under review.',
    validations_selfie_description: 'This helps us verify your identity and maintain security on the platform.',

    validations_facebook_title_default: 'Before continuing, add us on Facebook.',
    validations_facebook_title_pre_approved: 'Your validation has been approved.',
    validations_facebook_title_approved: 'Your validation has been approved.',
    validations_facebook_title_pending: 'Your validation is under review.',
    validations_facebook_title_processing: 'Your validation is under review.',
    validations_facebook_description: 'This process allows us to validate your user and communicate quickly through chat, if necessary.',

    validations_screenshot_title_default: 'We are waiting for your payment receipts.',
    validations_screenshot_title_pre_approved: 'Your payment receipts have been approved.',
    validations_screenshot_title_approved: 'Your payment receipts have been approved.',
    validations_screenshot_title_pending: 'Your payment receipts are under review.',
    validations_screenshot_title_processing: 'Your payment receipts are under review.',
    validations_screenshot_description:
        'You marked that you sent the balance, now we need the receipts of your payments. Remember they must be from your account.',

    validations_review_examples_title: 'If you have doubts, you can check the',
    validations_review_examples_link: 'examples of how to upload documentation.',

    validations_approve_time_message: 'Last document approved {{minutes}} min ago.',

    validations_create_button: 'Send to review',
    validations_cancel_button: 'Cancel',

    validations_file_uploader_drag_text: 'Drag and drop the image(s) here, paste with Ctrl+V or search for them on your computer',
    validations_file_uploader_uploading: 'Uploading...',

    validations_facebook_instruction_1: 'Use your personal profile, go to our profile and add us as a friend.',
    validations_facebook_instruction_2: 'Send us a message like this:',
    validations_facebook_message_template: 'Hello, my balance order is: *********',

    validations_empty_message: 'No validations found to complete.',

    validations_examples_title: 'Documentation examples',
    validations_examples_zoom_instruction: 'Tap an image to enlarge it',
    validations_examples_alt_approved: 'approved',
    validations_examples_alt_rejected: 'rejected',
    validations_examples_no_examples: 'No examples available to display.',
    validations_examples_alt_prefix: 'Example',

    validations_examples_title_id: 'Documentation examples',
    validations_examples_title_screenshot: 'Receipt examples',
    validations_examples_title_selfie: 'Selfie examples',

    validations_examples_instructions_id:
        "Upload an image of the front and back of your identity document, **well lit and focused**, placed on a blank sheet with the legend **'www.saldo.com.ar'** written by hand.",
    validations_examples_instructions_screenshot:
        'Upload a photo or screenshot of the **legible payment receipt**. Make sure you can see the **amount, date and recipient.**',
    validations_examples_instructions_selfie:
        "Upload a **well-lit and focused** selfie showing your face along with your identity document and a sheet with the phrase **'www.saldo.com.ar'** written by hand.",

    validations_examples_error_loading: 'Something went wrong loading the examples. Try again in a few minutes.',

    validations_example_image_title_default: 'Documentation example',
    validations_example_image_title_id: 'Documentation example',
    validations_example_image_title_screenshot: 'Receipt example',
    validations_example_image_title_selfie: 'Selfie example',
    validations_example_image_approved: 'Image accepted',
    validations_example_image_rejected: 'Image rejected'
};
